import { DocumentoAllegato } from './documento-allegato';
import { Persona } from './persona';
import { TariffaLegale } from './tariffa';
import { AmbitoCompetenza } from './tipologiche/ambito-competenza';

export class Legale extends Persona {
  documenti: DocumentoAllegato[];
  ambitiCompetenza: AmbitoCompetenza[];
  convenzione: boolean;
  tariffa: any;
  tariffe: TariffaLegale[];
  getAnagraficaTAG(): string {
    return 'legale';
  }
}
